/* Source: /home/sidsolaiyappan/skooch_ai/shared/mobile_tab_bar.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useStoreSlice, getStoreCurrentPage, subscribeStoreCurrentPage, getStoreAiPanelOpen, subscribeStoreAiPanelOpen, setStoreIsMobileViewport } from "./store.js";
import { computeActiveMobileTab, mobileTabClass } from "./mobile_nav_logic.js";
function initMobileViewportWatcher() {
  if (window.__skoochViewportWatcherInit) {
    return;
  }
  window.__skoochViewportWatcherInit = true;
  try {
    let _mq = window.matchMedia("(max-width: 767px)");
    setStoreIsMobileViewport(_mq.matches);
    _mq.addEventListener("change", _e => {
      setStoreIsMobileViewport(_e.matches);
    });
  } catch (__jac_e) {
    if (true) {
      let _e1 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    let _vm = document.querySelector("meta[name='viewport']");
    if (_vm) {
      _vm.setAttribute("content", "width=device-width, initial-scale=1, viewport-fit=cover");
    }
  } catch (__jac_e) {
    if (true) {
      let _e2 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function MobileTabBar(props) {
  const {callbacks} = props;
  initMobileViewportWatcher();
  let currentPage = useStoreSlice(getStoreCurrentPage, subscribeStoreCurrentPage);
  let aiPanelOpen = useStoreSlice(getStoreAiPanelOpen, subscribeStoreAiPanelOpen);
  let cb = callbacks;
  let onToday = cb["onToday"];
  let onWeek = cb["onWeek"];
  let onChat = cb["onChat"];
  let onProfile = cb["onProfile"];
  let _active = computeActiveMobileTab(currentPage, aiPanelOpen);
  return __jacJsx("nav", {"className": "mobile-tab-bar", "aria-label": "Primary"}, [__jacJsx("button", {"className": mobileTabClass("today", _active), "aria-label": "Today", "onClick": () => {
    onToday();
  }}, [__jacJsx("svg", {"viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "1.8", "strokeLinecap": "round", "strokeLinejoin": "round", "aria-hidden": "true"}, [__jacJsx("rect", {"x": "3.5", "y": "5", "width": "17", "height": "15.5", "rx": "2.5"}, []), __jacJsx("path", {"d": "M3.5 9.5h17"}, []), __jacJsx("path", {"d": "M8 3v3.5"}, []), __jacJsx("path", {"d": "M16 3v3.5"}, []), __jacJsx("circle", {"cx": "12", "cy": "15", "r": "2", "fill": "currentColor", "stroke": "none"}, [])]), "Today"]), __jacJsx("button", {"className": mobileTabClass("week", _active), "aria-label": "Schedule", "onClick": () => {
    onWeek();
  }}, [__jacJsx("svg", {"viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "1.8", "strokeLinecap": "round", "strokeLinejoin": "round", "aria-hidden": "true"}, [__jacJsx("rect", {"x": "3.5", "y": "5", "width": "17", "height": "15.5", "rx": "2.5"}, []), __jacJsx("path", {"d": "M3.5 9.5h17"}, []), __jacJsx("path", {"d": "M9.2 9.5v11"}, []), __jacJsx("path", {"d": "M14.8 9.5v11"}, [])]), "Schedule"]), __jacJsx("button", {"className": mobileTabClass("chat", _active), "aria-label": "Chat with Skooch", "onClick": () => {
    onChat();
  }}, [__jacJsx("svg", {"viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "1.8", "strokeLinecap": "round", "strokeLinejoin": "round", "aria-hidden": "true"}, [__jacJsx("path", {"d": "M21 11.5a8.4 8.4 0 0 1-8.5 8.3 8.9 8.9 0 0 1-3.2-.6L4 20.5l1.4-4A8 8 0 0 1 4 11.5 8.4 8.4 0 0 1 12.5 3.2 8.4 8.4 0 0 1 21 11.5z"}, []), __jacJsx("circle", {"cx": "9", "cy": "11.7", "r": "0.9", "fill": "currentColor", "stroke": "none"}, []), __jacJsx("circle", {"cx": "12.5", "cy": "11.7", "r": "0.9", "fill": "currentColor", "stroke": "none"}, []), __jacJsx("circle", {"cx": "16", "cy": "11.7", "r": "0.9", "fill": "currentColor", "stroke": "none"}, [])]), "Chat"]), __jacJsx("button", {"className": mobileTabClass("profile", _active), "aria-label": "Profile", "onClick": () => {
    onProfile();
  }}, [__jacJsx("svg", {"viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "1.8", "strokeLinecap": "round", "strokeLinejoin": "round", "aria-hidden": "true"}, [__jacJsx("circle", {"cx": "12", "cy": "8.2", "r": "3.6"}, []), __jacJsx("path", {"d": "M5 20.2a7.2 7.2 0 0 1 14 0"}, [])]), "Profile"])]);
}
export {MobileTabBar, initMobileViewportWatcher};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:initMobileViewportWatcher": {"is_writer": true, "touches": ["*"]}, "func:MobileTabBar": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=mobile_tab_bar.js.map
